<template>
  <SeoPage page-key="agenziaMarketingDigitaleChiasso" />
</template>

<script setup>
import SeoPage from '../components/SeoPage.vue'

defineOptions({
  name: 'AgenziaMarketingDigitaleChiassoPage'
})
</script>

